<template>
  <div class="eventInformation">
    <v-container>
      <v-layout>
        <v-flex md8 xs12 class="terms">
          <h3>Missing Token</h3>
          <p>The link to accept the terms and conditions is personalized for each registered team member. Please click the link from the automated email to review your personalized agreement.</p>
          <p>If you still encounter issues, please contact support at <a :href="'mailto:'+contactAddress">{{ contactAddress }}</a>.</p>

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.eventInformation{
  min-height: 400px;
}
</style>
<script>
export default {
  computed: {
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    }
  }
}
</script>
